import React from "react";
import { Navigate } from "react-router-dom";
import {
    decodeAuthTokenClaims,
    shouldUseUserAccountsExperience,
} from "shared/utils/userAccountSession";
import {useUserAccountsAccessProfile} from "shared/hooks/useUserAccountsAccessProfile";
import "./AdminProtectedRoute.css";

interface BusinessProtectedRouteProps {
    children: React.ReactElement;
    requireSuperAdminForUserAccounts?: boolean;
}

const BusinessProtectedRoute: React.FC<BusinessProtectedRouteProps> = ({
    children,
    requireSuperAdminForUserAccounts = false,
}) => {
    const token = localStorage.getItem("authToken");
    const decoded = decodeAuthTokenClaims(token);
    const usesUserAccounts = shouldUseUserAccountsExperience(decoded);
    const {
        profile: userAccessProfile,
        isLoading: isUserAccessProfileLoading,
    } = useUserAccountsAccessProfile(
        usesUserAccounts,
        decoded?.auth_user_id,
        decoded?.email
    );
    
    if (!token) {
        return <Navigate to="/" replace />;
    }

    if (!decoded) {
        return <Navigate to="/" replace />;
    }

    if (usesUserAccounts) {
        if (isUserAccessProfileLoading) {
            return (
                <div className="no-access-page" dir="rtl">
                    <div className="no-access-card">
                        <div className="no-access-title">בודקים הרשאות…</div>
                        <div className="no-access-subtitle">רק רגע.</div>
                    </div>
                </div>
            );
        }

        if (!userAccessProfile || userAccessProfile.user.isActive !== true) {
            return <Navigate to="/" replace />;
        }

        const allowed = requireSuperAdminForUserAccounts
            ? userAccessProfile.capabilities.canAccessGlobalAdminTools === true
            : userAccessProfile.capabilities.canViewBusinessWorkspace === true;

        return allowed ? children : <Navigate to="/" replace />;
    }

    if (String(decoded.business_id ?? "") === "1") {
        return children;
    }

    return <Navigate to="/" replace />;
};

export default BusinessProtectedRoute;
